<template>
  <div class="absolute inset-0 lg:w-full lg:h-full">
    <swiper
      v-if="images && images.length > 0"
      :options="swiperOptions"
      class="h-full"
    >
      <swiper-slide v-for="(item, index) in images" :key="index">
        <figure
          class="image-caption-wrapper h-full"
          :class="
            swiperBackgroundColour ? `bg-${swiperBackgroundColour}` : 'bg-white'
          "
        >
          <img
            class="w-full h-full object-cover"
            :src="item.url"
            :alt="item.title || item.text"
          />

          <figcaption
            v-if="item.text"
            class="image-caption pb-6 lg:pb-8"
            v-html="item.text"
          ></figcaption>
        </figure>
      </swiper-slide>
      <div slot="pagination" class="swiper-pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import axios from "axios";

export default {
  name: "SliderSimple",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    entry: {
      type: Number,
      default: null
    },
    block: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      images: null,
      swiperOptions: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true
        },
        autoplay: true,
        speed: 750
      }
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      axios({
        url: "/api",
        method: "post",
        data: {
          query: `
            query sliderQuery($entry: [QueryArgument], $block: [QueryArgument]) {
              entries(id: $entry) {
                ... on home_home_Entry {
                  id
                  contentAndSlider(id: $block) {
                    ... on contentAndSlider_BlockType {
                      id
                      imagesBackgroundColour
                      images {
                        url
                        ... on images_Asset {
                          id
                          text
                        }
                      }
                    }
                  }
                }
                ... on objectsIndex_objectsIndex_Entry {
                  id
                  contentAndSlider(id: $block) {
                    ... on contentAndSlider_BlockType {
                      imagesBackgroundColour
                      id
                      images {
                        url
                        ... on images_Asset {
                          id
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: {
            entry: this.entry,
            block: this.block
          }
        }
      }).then(result => {
        let data;
        let imagesBackgroundColour;
        const { contentAndSlider } = result.data.data.entries[0];

        if (contentAndSlider && contentAndSlider.length) {
          data = contentAndSlider[0].images;
          imagesBackgroundColour = contentAndSlider[0].imagesBackgroundColour;
        }

        this.images = data;
        this.swiperBackgroundColour = imagesBackgroundColour;
      });
    }
  }
};
</script>

<style>
.swiper-pagination-bullet {
  background: white;
  opacity: 100;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: black;
}
</style>
